import { components } from "@/lib/ApiSchema";
import { _fetch } from "@/lib/queries/apis";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router";

export default function useSaveLineItems() {
  const queryClient = useQueryClient();
  const { teamSlug } = useParams();
  return useMutation({
    mutationFn: async ({
      quoteRevisionId,
      lineItems,
    }: {
      quoteRevisionId: string;
      lineItems: components["schemas"]["LineItemSchema"][];
    }) => updateLineItems(teamSlug!, quoteRevisionId, lineItems),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          "get",
          "/api/teams/{team_slug}/quote_revisions/{id}/line_items",
        ],
      });
    },
  });
}

async function updateLineItems(
  team: string,
  quoteRevisionId: string,
  lineItems: components["schemas"]["LineItemSchema"][],
): Promise<unknown> {
  return _fetch(
    `teams/${team}/quote_revisions/${quoteRevisionId}/line_items`,
    "PUT",
    lineItems,
  );
}
